import h from './helpers.js'

const formatPrice = price => {
	price = price / 100
	price = price.toLocaleString("en-US", { style: "currency", currency: "USD" })
	return price
}

const select = function(e) {
	
	const selectedClass = "reprint__piece--selected"

	// Get parent element
	const reprint = document.querySelector('.reprint')
	
	// Validate original order ID
	const orderIdInput = document.querySelector('.js-reprint-order-id')
	const originalOrderID = orderIdInput.value
	if (originalOrderID.length < 1) {
		orderIdInput.closest('label').classList.add('error')
		alert('Please enter your original order number first')
		e.preventDefault()
		return false
	} else {
		orderIdInput.closest('label').classList.remove('error')
	}
	
	// Reset totals
	Reprint.totalPrice = 0
	Reprint.pieces = []
	
	// Cycle through all selected pieces and add up price + gather ID's
	reprint.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
		if (checkbox.checked) {
			checkbox.closest('label').classList.add(selectedClass)
			Reprint.totalPrice += parseInt(checkbox.dataset.price)
			Reprint.pieces.push({
				quantity: 1,
				id: checkbox.dataset.id,
				properties: {
					'Original Order ID': originalOrderID
				}
			})
		} else {
			checkbox.closest('label').classList.remove(selectedClass)
		}
	})
	
	// Format and display price
	const formattedPrice = formatPrice(Reprint.totalPrice)
	const priceElement = document.querySelector('[data-product-price]')
	priceElement.innerHTML = formattedPrice
	
}

// TODO: Make sure this works on the actual shop
const submit = async function(e) {
	
	e.preventDefault()
	
	if (Reprint.pieces.length < 1) {
		alert('Please choose some items to reprint')
		return false
	}
	
	// Wrap items for submittion
	const items = { items: Reprint.pieces }
	
	const data = await fetch(`/cart/add.js`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(items),
	}, items)
	
	const response = await data.json()
	
	window.location.href = "/cart"
	
}

const Reprint = {
	
	// Create defaults accessible from everywhere
	total: 0,
	pieces: [],
	
	setup() {
	
		const reprint = document.querySelector('.reprint')
		
		// Stop of element not present
		if (!reprint) return
		
		// Checkbox Selection
		h.on('click', '.reprint__checkbox', select)
		
		// Form submit
		h.on('submit', '.reprint', submit)
		
	},

}

export default Reprint
